<div [class]="getTypeIdString()" class="badge">
  {{ 'facility_type.' + getTypeIdString() | translate }}
</div>
